import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as actions from 'actions';
import { screenService } from 'frontend-component-library';
import highlightingService from 'services/highlightingService';

import Tag from './Tag';

class HoverableTag extends PureComponent {
  constructor(props) {
    super(props);
    // TODO: Use this for mobile
    this.state = {
      infoOpen: false,
    };
  }

  openTag = () => {
    highlightingService.highlightTag(this.props.tag);
    this.setState({ infoOpen: true });
  };

  closeTag = event => {
    highlightingService.resetHighlighting(event);
    this.setState({ infoOpen: false });
  };

  handleClick = () => {
    if (screenService.isTouchDevice()) {
      this.openTag();
    } else {
      this.props.addTagFilter(this.props.tag);
    }
  };

  render() {
    const { tag, isDimmed } = this.props;
    const hoverEvents = {
      onMouseEnter: this.openTag,
      onMouseLeave: this.closeTag,
    };
    return (
      <Tag
        tag={tag}
        isOpen={this.state.infoOpen}
        isDimmed={isDimmed}
        closeInfoWindow={this.closeTag}
        showInfoWindow={true}
        onClick={this.handleClick}
        hoverEvents={hoverEvents}
      />
    );
  }
}

HoverableTag.propTypes = {
  tag: PropTypes.shape({
    id: PropTypes.number,
    schema: PropTypes.string,
    displayClass: PropTypes.string,
  }).isRequired,
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      addTagFilter: actions.addTagFilter,
    },
    dispatch
  );
}

export default connect(undefined, mapDispatchToProps)(HoverableTag);



// WEBPACK FOOTER //
// ./src/Components/Pages/Results/Tags/HoverableTag.js